import { z } from "zod";

/**
 * Approve Phone Number Request Body Schema
 *
 * Used by admins to approve a request and assign a phone number.
 */
export const ApprovePhoneNumberRequestBodySchema = z.object({
  phoneNumber: z.string().min(1, "Phone number required"),
  phoneNumberSid: z.string().min(1, "Phone number SID required"),
  adminNotes: z.string().max(500, "Admin notes must be less than 500 characters").optional()
});

export type ApprovePhoneNumberRequestBody = z.infer<typeof ApprovePhoneNumberRequestBodySchema>;

/**
 * Approve Response
 */
export const ApprovePhoneNumberRequestResponseSchema = z.object({
  requestId: z.string().uuid(),
  phoneNumberId: z.string().uuid(),
  status: z.string()
});

export type ApprovePhoneNumberRequestResponse = z.infer<
  typeof ApprovePhoneNumberRequestResponseSchema
>;

/**
 * Reject Phone Number Request Body Schema
 *
 * Used by admins to reject a request.
 */
export const RejectPhoneNumberRequestBodySchema = z.object({
  rejectionReason: z
    .string()
    .min(10, "Please provide at least 10 characters explaining why this was rejected")
    .max(500, "Rejection reason must be less than 500 characters")
    .trim(),

  adminNotes: z.string().max(500, "Admin notes must be less than 500 characters").optional()
});

export type RejectPhoneNumberRequestBody = z.infer<typeof RejectPhoneNumberRequestBodySchema>;

/**
 * Reject Response
 */
export const RejectPhoneNumberRequestResponseSchema = z.object({
  requestId: z.string().uuid(),
  status: z.string()
});

export type RejectPhoneNumberRequestResponse = z.infer<
  typeof RejectPhoneNumberRequestResponseSchema
>;
